<script>
import MethodButtonBase from './MethodButtonBase';
import LvIdIcon from '../../assets/svg/e-paraksts-mark.svg';
export default {
  name: 'IdCardButtonLv',
  components: {
    MethodButtonBase,
    LvIdIcon,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <LvIdIcon :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('eparaksts-eid') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 27px;
  height: auto;
  margin-right: 8px;
}
</style>
